import { selector, useRecoilValue } from 'recoil';
import { getLoadedLibraryData } from './raw-library-data';

interface AudienceSettings {
    adultOnly: boolean;
    all: boolean;
    generalContent: boolean;
    juvenile: boolean;
    youngAdult: boolean;
}

interface UserInfo {
    advantageDismissed: boolean;
    audienceSettings: AudienceSettings;
    correlationId: string;
    dyslexic: boolean;
    hasLinkedCards: boolean;
    isLoggedIn: boolean;
    isVisitor: boolean;
    locale: string;
    selectedCardId: string;
    showOnlyAvailable: boolean;
    isDefault: boolean;
}

const DEFAULT_USER_INFO: UserInfo = {
    advantageDismissed: false,
    audienceSettings: {
        adultOnly: false,
        all: true,
        generalContent: false,
        juvenile: false,
        youngAdult: false,
    },
    correlationId: '',
    dyslexic: false,
    hasLinkedCards: false,
    isLoggedIn: false,
    isVisitor: false,
    locale: 'en',
    selectedCardId: '',
    showOnlyAvailable: false,
    isDefault: true,
};

const userInfoState = selector<UserInfo>({
    key: 'UserInfo',
    get: ({ get }) => {
        const data = getLoadedLibraryData(get);
        if (!data) {
            return DEFAULT_USER_INFO;
        }

        const audienceSettings = data.patronSettings?.['audience-setting'];
        const languageSelection = data.patronSettings?.['language-selection'];

        return {
            advantageDismissed: !!data.advantageDismissed,
            audienceSettings: {
                adultOnly: !!audienceSettings?.adultonly,
                all: audienceSettings?.all ?? true,
                generalContent: !!audienceSettings?.generalcontent,
                juvenile: !!audienceSettings?.juvenile,
                youngAdult: !!audienceSettings?.youngadult,
            },
            correlationId: data.correlationId,
            dyslexic: data.dyslexic,
            hasLinkedCards: !!data.hasLinkedCards,
            isLoggedIn: data.isAuthenticated,
            isVisitor: !!data.IsVisitor,
            locale: languageSelection ?? data.locale ?? 'en',
            selectedCardId: data.selectedCardId,
            showOnlyAvailable: !!data.patronSettings?.showOnlyAvailable,
            isDefault: false,
        } as UserInfo;
    },
});

export const useUserInfo = () => useRecoilValue(userInfoState);
